var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "giftInventory"
  }, [_c('n-gift-head', {
    ref: "nGiftHeadRef"
  }), _c('div', {
    staticClass: "giftInventory-body page-body"
  }, [_c('div', {
    staticClass: "giftInventory-main page-main"
  }, [_vm.isPageLoading ? _c('div', {
    staticClass: "giftInventory-loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]) : _vm._e(), _c('div', {
    staticClass: "giftInventory-list"
  }, _vm._l(_vm.logs, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "giftInventory-item"
    }, [_c('div', {
      staticClass: "giftInventory-gift"
    }, [_c('div', {
      staticClass: "giftInventory-item-img"
    }, [_c('img', {
      attrs: {
        "src": item.gift_thumb,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "giftInventory-item__label"
    }, [_vm._v(_vm._s(item.item_title))])]), item.order_id <= 0 ? _c('div', {
      staticClass: "giftInventory-item-btns"
    }, [_c('div', {
      staticClass: "btn btn-getTelegram",
      on: {
        "click": function ($event) {
          return _vm.onGetToTelegram(item);
        }
      }
    }, [_vm._v("Get to Telegram")]), _c('div', {
      staticClass: "btn btn-sell-star",
      on: {
        "click": function ($event) {
          return _vm.onSellPlatform(item);
        }
      }
    }, [_vm._v("Sell it for "), _c('img', {
      attrs: {
        "src": require(`@images/tapcoin/ton-stars.png`),
        "alt": ""
      }
    }), _vm._v(_vm._s(_vm.fmt_pre(item.recycling_stars)))])]) : item.order_id > 0 && item.order_status == 0 ? _c('div', {
      staticClass: "giftInventory-item-btns"
    }, [_c('div', {
      staticClass: "btn btn-getTelegram",
      on: {
        "click": function ($event) {
          return _vm.onGetToTelegram(item);
        }
      }
    }, [_vm._v("Get to Telegram")])]) : _vm._e(), item.order_id > 0 && item.order_status == 2 ? _c('div', {
      staticClass: "giftInventory-tag-sold"
    }, [_vm._v("Sold")]) : item.order_id > 0 && item.order_status == 1 ? _c('div', {
      staticClass: "giftInventory-tag-sold"
    }, [_vm._v("Received")]) : item.order_id > 0 && item.order_status == 0 ? _c('div', {
      staticClass: "giftInventory-tag-sold distributing"
    }, [_vm._v("Distributing")]) : _vm._e()]);
  }), 0)])]), _c('pop-sell-gift', {
    ref: "popSellGiftRef",
    on: {
      "finish": _vm.popSellGiftFinish
    }
  }), _c('div', {
    staticClass: "mMenu"
  }, [_c('m-menu')], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };